import { Stack, Typography, alpha } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  text: React.ReactNode;
  icon: React.ReactNode;
  tone?: 'info' | 'warning';
}

/**
 * Der Hinweiskasten des Assistenten: ein Symbol, ein Satz, kein Titel.
 *
 * Er trägt genau die Sätze, die der Kunde vorher erst im Support erfuhr — dass gleich
 * das Handy gebraucht wird, wozu die feste IP da ist, dass nach dem ersten Code noch
 * ein zweiter kommt.
 */
const StepHint: React.FC<Props> = ({ text, icon, tone = 'info' }) => {
  const { classes, cx } = useStyles();

  return (
    <Stack className={cx(classes.hint, tone)} direction={'row'} gap={1.5} alignItems={'flex-start'}>
      <div className={cx(classes.icon, tone)}>{icon}</div>
      <Typography className={cx(classes.text, tone)}>{text}</Typography>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  hint: {
    padding: '14px 15px',
    borderRadius: '10px',
    '&.info': {
      background: alpha(theme.palette.secondary.main, 0.07),
    },
    '&.warning': {
      background: theme.palette.backgrounds.lightOrange,
    },
  },
  icon: {
    display: 'flex',
    flex: '0 0 auto',
    marginTop: '1px',
    '& svg': {
      fontSize: theme.typography.pxToRem(19),
    },
    '&.info svg': {
      color: theme.palette.secondary.main,
    },
    '&.warning svg': {
      color: theme.palette.warning.main,
    },
  },
  text: {
    fontSize: theme.typography.pxToRem(13),
    lineHeight: 1.5,
    '&.info': {
      color: theme.palette.secondary.dark,
    },
    '&.warning': {
      color: theme.palette.warning.dark,
    },
  },
}));

export default StepHint;
